import AdaptivePopup from '../../../../../../../../components/AdaptivePopup/AdaptivePopup';
import { CrossIcon } from '../../../../../../../../assets/icons/controls/controls';
import { useEffect, useMemo, useState } from 'react';
import { TYPE_MAP } from '../../utils/editMainPageConstants';

function renderBlockPreview(type) {
    if (!type) return null;
    const meta = TYPE_MAP[type];
    if (meta?.preview) {
        return <img className="edit-main-page__block-preview-image" src={meta.preview} alt="" />;
    }
    return <div className="edit-main-page__block-preview-placeholder" />;
}

function BlockPickerPopup({ isOpen, onClose, selectableBlocks, onSelectBlock }) {
    const [adminClicks, setAdminClicks] = useState(0);
    const isAdminVisible = adminClicks >= 5;

    useEffect(() => {
        if (isOpen) return;
        setAdminClicks(0);
    }, [isOpen]);

    useEffect(() => {
        if (!isOpen) return undefined;
        const { body } = document;
        const prevOverflow = body.style.overflow;
        body.style.overflow = 'hidden';
        return () => {
            body.style.overflow = prevOverflow;
        };
    }, [isOpen]);

    const filteredBlocks = useMemo(() => {
        if (isAdminVisible) return selectableBlocks;
        return selectableBlocks.filter((block) => Boolean(TYPE_MAP[block.type]?.form));
    }, [selectableBlocks, isAdminVisible]);

    return (
        <AdaptivePopup className={`edit-main-page__block-picker-popup`} isOpen={isOpen} handleClose={onClose}>
            <div className='edit-main-page__block-picker'>
                <div className='edit-main-page__block-picker-header'>
                    <p
                        className='edit-main-page__block-picker-title'
                        onClick={() => setAdminClicks((prev) => Math.min(prev + 1, 5))}
                    >
                        Добавить блок
                    </p>
                    <button
                        className='edit-main-page__block-picker-close'
                        type='button'
                        onClick={onClose}
                    >
                        <CrossIcon
                            mainClassName='edit-main-page__block-picker-close-icon'
                            strokeClassName='edit-main-page__block-picker-close-icon-stroke'
                        />
                    </button>
                </div>
                <div className='edit-main-page__block-picker-grid'>
                    {filteredBlocks.length > 0 ?
                        filteredBlocks.map((block) => (
                            <button
                                className='edit-main-page__block-picker-card'
                                type='button'
                                key={block._id || block.type}
                                onClick={() => onSelectBlock(block)}
                            >
                                <div className='edit-main-page__block-picker-preview'>
                                    {renderBlockPreview(block.type)}
                                </div>
                                <div className='edit-main-page__block-picker-card-title'>
                                    {TYPE_MAP[block.type]?.title || block.title || block.type}
                                </div>
                            </button>
                        ))
                        :
                        <div className='edit-main-page__block-picker-empty'>
                            Нет доступных блоков для добавления.
                        </div>}
                </div>
            </div>
        </AdaptivePopup>
    );
}

export default BlockPickerPopup;
